


























































































































import { Component, Vue } from "vue-property-decorator";

import MemberList from "@/components/sale/list/MemberList.vue";
import Search from "@/components/Search.vue";
import { IMemberListRequest } from "@/types/member";
import { Action, Getter } from "vuex-class";
import { ISkillListRequest } from "@/types/skill";
import { ISelectItem } from "@/types";
import { MemberListRequest } from "@/models/member";

@Component({
  components: { MemberList, Search },
})
export default class extends Vue {
  @Action("skill/getList")
  public getSkillList!: (params: ISkillListRequest) => Promise<void>;

  @Getter("skill/selectItem")
  public skillItems!: ISelectItem;

  public params: IMemberListRequest = new MemberListRequest();

  public dialog = false;

  private created(): void {
    this.getSkillList({ per_page: 0 });
  }

  public search(): void {
    const target = this.$refs.memberlist as MemberList;
    target.getList();
  }
}
